import axios from 'axios';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Loading from '../Loading/Loading';
import MyWorkDetails from '../MyWorkDetails/MyWorkDetails';
import './MyWork.css'

function titlee() {
  return document.getElementById('titlee');
}

let title = titlee();

class MyWork extends Component {
  constructor(props) {
    super(props);
    this.state = {
      line1: 'My Projects !!',
      textAnimationLine1: [],
      loading: false,
      myWorkProjectData: [],
      myWorkProjectDataUrl: 'https://my-webpage-node.vercel.app/MyWork/',
      ShowPopUp: false,
      ShowPopUpId: ''
    }
  }
  async componentDidMount() {
    title.innerHTML = 'MyWork'
    let tempArr1 = []
    if (this.state.textAnimationLine1.length !== 40) {
      for (let i = 0; i < 40; i++) {
        tempArr1[i] = { letterAni: 0 }
      }
    }
    this.setState({
      textAnimationLine1: tempArr1,
    })
    let myWorkPage = {
      SelectedPage: 3
    }
    this.props.SelectedPage('SelectedPage', myWorkPage)
    var countDownAni = 0;
    setInterval(() => {
      if ((countDownAni) < 40 && this.state.loading && this.props.MyWorkProps.MyWorkPage.Loading) {
        let arr1 = this.state.textAnimationLine1;
        if (countDownAni === 0) {
          arr1[countDownAni] = { letterAni: 1 }
          countDownAni++;
          this.setState({
            textAnimationLine1: arr1,
          })
        } else {
          arr1[countDownAni - 1] = { letterAni: 2 }
          arr1[countDownAni] = { letterAni: 1 }
          countDownAni++;
          this.setState({
            textAnimationLine1: arr1,
          })
        }
      }
    }, 100);
    await axios.get(this.state.myWorkProjectDataUrl).then((data) => {
      this.setState({
        myWorkProjectData: data.data,
        loading: true
      })
    })
  }

  render() {
    return (<>
      {this.state.loading && this.props.MyWorkProps.MyWorkPage.Loading ? <>
        <div className='myWorkProjectMainDivision'>
          <div className='mainDivMyWorkPage'>
            <div className='TextDivisionMyWork'>
              <div>
                {this.state.line1.split('').map((ite, index) => {
                  return (<>{ite === ' ' ? <span className='MyWorkAniLetterSpace'>{ite}</span> : <span onMouseEnter={() => {
                    let ani = this.state.textAnimationLine1
                    ani[index] = { letterAni: 1 }
                    this.setState({
                      textAnimationLine1: ani
                    })
                  }} onMouseLeave={() => {
                    setTimeout(() => {
                      let ani = this.state.textAnimationLine1
                      ani[index] = { letterAni: 2 }
                      this.setState({
                        textAnimationLine1: ani
                      })
                    }, 500)
                  }} className={this.state.textAnimationLine1[index]?.letterAni === 0 || undefined || null ? 'MyWorkAniLtr' : this.state.textAnimationLine1[index]?.letterAni === 1 ? 'MyWorkAniLetterMouse MyWorkAniLetter' : 'MyWorkAniLetter'}>{ite}</span>}
                  </>)
                })}
              </div>
            </div>
          </div>
          <div className='MyWorkProjectDiv'>
            {this.state?.myWorkProjectData.map((ite, index) => {
              if (ite?.projectShow) {
                return (<>
                  <div onClick={() => {
                    this.setState({
                      ShowPopUpId: ite._id,
                      ShowPopUp: true
                    })
                  }} className='MyWorkProjectSubDiv'>
                    <h1 className='myWorkProjectHeadingMain'>{ite.projectname}</h1>
                    <img className='MyWorkProjectImage' src={`https://drive.google.com/uc?export=view&id=${ite.projectImage}`} alt={ite?.projectImage} />
                  </div>
                </>)
              } else {
                return (<></>)
              }
            })}
          </div>
          {this.state.ShowPopUp ?
            <div className='myWorkPopUpDivision'>
              <MyWorkDetails valueMyWork={`https://my-webpage-node.vercel.app/MyWork/${this.state.ShowPopUpId}`} Selected={true} closePopUp={(e) => {
                if (e) {
                  this.setState({
                    ShowPopUp: false
                  })
                }
              }} />
            </div>
            : ''}
        </div>
      </>
        : <Loading />}
    </>);
  }
}

const mapStateToProps = (state) => ({
  MyWorkProps: state.Reducer
})

const mapDispatchToProps = (dispatch) => ({
  SelectedPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  }),
  LoadingPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  })
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyWork));